import gql from 'graphql-tag';

const eventTypeCatalogFragment = gql`
  fragment eventTypeCatalogParts on EventTypeCatalogItem {
    value
    code
    description
  }
`;

export const eventTypeCatalog = gql`
  query eventTypeCatalog {
    eventTypeCatalog {
      ...eventTypeCatalogParts
    }
  }
  ${eventTypeCatalogFragment}
`;
